export default __webpack_public_path__ + "static/media/crm.443c5b6e.svg";